import { render, staticRenderFns } from "./ContentPad.vue?vue&type=template&id=22784dbb&scoped=true"
var script = {}
import style0 from "./ContentPad.vue?vue&type=style&index=0&id=22784dbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22784dbb",
  null
  
)

export default component.exports